function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.77 2.61a1.36 1.36 0 01.16-.56 1.64 1.64 0 01.46-.5 1.89 1.89 0 01.61-.3 2.64 2.64 0 01.68-.09 2.44 2.44 0 011.13.26 2.21 2.21 0 01.8.67l1-1A3.23 3.23 0 005.38.31 4.27 4.27 0 003.75 0a4.77 4.77 0 00-1.22.16 3.27 3.27 0 00-1.09.51 2.73 2.73 0 00-.78.88 2.54 2.54 0 00-.3 1.27A2.63 2.63 0 00.57 4v.07a3.14 3.14 0 011.2-1.46zM6.47 6.29a3.14 3.14 0 01-1.23 1.54 1.36 1.36 0 01-.15.46 1.69 1.69 0 01-.47.53 2 2 0 01-.62.31 2.64 2.64 0 01-2-.23 2.63 2.63 0 01-.94-.84L0 9a3.6 3.6 0 001.45 1.08 4.67 4.67 0 001.81.36 4.55 4.55 0 001.28-.18 3.24 3.24 0 001.1-.55 2.74 2.74 0 00.76-.94 2.92 2.92 0 00.29-1.34 2.58 2.58 0 00-.22-1.14z",
  fill: "#d2d2d2",
  className: "svg-no-adaptive-fill"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.47 6.29v-.11a2.55 2.55 0 00-.69-.81 3.69 3.69 0 00-.94-.52q-.52-.19-1-.35L3 4.23a2.74 2.74 0 01-.64-.32 1.46 1.46 0 01-.43-.46 1.32 1.32 0 01-.16-.68v-.16A3.14 3.14 0 00.62 4.05a2.37 2.37 0 00.54.7 3.26 3.26 0 00.84.52 7.81 7.81 0 00.94.34l.9.3a3.43 3.43 0 01.75.36 1.67 1.67 0 01.51.51 1.38 1.38 0 01.19.75 1.79 1.79 0 010 .3 3.14 3.14 0 001.18-1.54z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6.69 10.42"
  }, props), _ref, _ref2);
};

export default SvgComponent;